import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import { Button, Card } from 'react-bootstrap'
import CardBodyContainer from '../../../common/styles/CardBodyContainer'
import CardTitle from '../../../common/styles/CardTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import useLibraryNear from '../../library/useLibraryNear'
import useCurrentLocation from '../../library/useCurrentLocation'
import NoContentForFullScreen from '../../../common/NoContentForFullScreen'
import ReloadButton from '../../../common/styles/ReloadButton'
import LibraryCard from '../../library/find/LibraryCard'
import LibraryCardLoading from '../../library/find/LibraryCardLoading'
import LoadingBar from '../../../common/LoadingBar'
import RowSpacer from '../../../common/styles/RowSpacer'
import ColorConfig from '../../../config/ColorConfig'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import useLocationStore from "../../library/useLocationStore";

interface Props {
	isIndex?: boolean
}

const IndexLibraryCard: React.FC<Props> = ({ isIndex }) => {
	const [isLocationActive, setIsLocationActive] = useState<boolean>(localStorage.getItem('location') !== null)

	const [lat, long, locationName, isLocationLoading, locationError, refreshLocation] = useCurrentLocation(isLocationActive)
	const [libraries, isLibraryLoading] = useLibraryNear(lat, long)

	const {setCoordinates} = useLocationStore()

	const makeLocationActive = () => {
		setIsLocationActive(true)
		localStorage.setItem('location', 'true')
	}

	useEffect(() => {
		setCoordinates(lat, long)
	}, [lat, long])

	return (
		<Card>
			{isIndex ? (
				<CardBodyContentContainer height={600} style={!isLocationActive ? { display: 'flex', flexDirection: 'column' } : undefined}>
					<CardTitle icon={<booksitoutIcon.library />} title={'내 근처 도서관'} subTitle={isLocationLoading ? <LoadingBar size={4} /> : locationName ?? ''} url="/library/near" />

					<ReloadButton onClick={refreshLocation} />

					{!isLocationActive ? (
						<LocationRequestCard requestLocation={makeLocationActive} />
					) : (
						<Row>
							{locationError ? (
								<></>
							) : isLocationLoading || isLibraryLoading ? (
								Array.from({ length: 8 }).map(_ => (
									<Col>
										<LibraryCardLoading />
									</Col>
								))
							) : libraries.length === 0 ? (
								<NoContentForFullScreen message={'근처에 도서관이 없어요'} />
							) : (
								libraries.slice(0, 8).map(library => (
									<Col>
										<LibraryCard library={library} backgroundColorType={'card-card'} />
									</Col>
								))
							)}
						</Row>
					)}
				</CardBodyContentContainer>
			) : (
				<CardBodyContainer style={!isLocationActive ? { display: 'flex', flexDirection: 'column' } : undefined}>
					<CardTitle icon={<booksitoutIcon.library />} title={'내 근처 도서관'} subTitle={isLocationLoading ? <LoadingBar size={4} /> : locationName ?? ''} url="/library/near" />

					<ReloadButton onClick={refreshLocation} />

					{!isLocationActive ? (
						<LocationRequestCard requestLocation={makeLocationActive} />
					) : (
						<Row>
							{locationError ? (
								<></>
							) : isLocationLoading || isLibraryLoading ? (
								Array.from({ length: 8 }).map(_ => (
									<Col>
										<LibraryCardLoading />
									</Col>
								))
							) : libraries.length === 0 ? (
								<NoContentForFullScreen message={'근처에 도서관이 없어요'} />
							) : (
								libraries.slice(0, 8).map(library => (
									<Col>
										<LibraryCard library={library} backgroundColorType={'card-card'} />
									</Col>
								))
							)}
						</Row>
					)}
				</CardBodyContainer>
			)}
		</Card>
	)
}

interface LocationRequestCardProps {
	requestLocation: () => void
}

const LocationRequestCard: React.FC<LocationRequestCardProps> = ({ requestLocation }) => {
	return (
		<LocationContainer>
			<Button onClick={requestLocation} variant={'book'}>
				현재 위치 허용하고 근처 도서관 보기
			</Button>
			<RowSpacer size={10} />
			<LocationDisclaimer>
				위치 정보는 성능을 위해 컴퓨터에만 임시로 저장되고 서버에는 저장되지 않아요. 자세한건 <LocationDisclaimerLink href={'https://booksitout.com/privacy/2023-07-01?language=KOREAN'}>개인정보처리방침</LocationDisclaimerLink>을 참고해 주세요.
			</LocationDisclaimer>
		</LocationContainer>
	)
}

const LocationContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1;
`

const LocationDisclaimer = styled.p`
	font-size: 0.8rem;
	color: #6c757d;
	text-align: center;
`

const LocationDisclaimerLink = styled.a`
	color: ${ColorConfig.Primary};
	font-weight: bold;
`

const Row = styled.div.attrs({
	className: 'row',
})``

const Col = styled.div.attrs({
	className: 'col-12 col-md-6',
})``

export default IndexLibraryCard
